<template>
  <keep-alive>
    <router-view :key="$route.path"></router-view>
  </keep-alive>
</template>

<script>
export default {
  name: 'Reports'
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Reports/Reports.vue